import { createAction } from '@reduxjs/toolkit';
export const ADD_ANALYTIC_TEAM_MEMBER = 'ADD_ANALYTIC_TEAM_MEMBER';
export const addAnalyticTeamMemberAction = createAction(ADD_ANALYTIC_TEAM_MEMBER);